import styled from 'styled-components';

export const MapUnavailableText = styled.span`
  font-size: 16px;
  font-weight: 500;
  line-height: 19px;
`;
